<script>
import lazyLoadComponent from '@router/lazyload-component'
import cloneDeep from 'lodash/cloneDeep'
import {
  genderFilter,
  paymentStatusMapFilter,
  taxTypeMap,
  carrierTypeMap,
  orderPaymentMethodMap,
  orderStatusFilter,
  orderSourceFilter,
  orderPaymentMethodFilter,
} from '@utils/filter-value-to-text'
import formatDate from '@utils/format-date'
import { Clipboard } from '@capacitor/clipboard'
import depositOrderMixin from '@/src/mixins/depositOrderMixin'
const initData = () => {
  return {
    params: [],
    fullName: '',
    gender: 'male',
    phoneCode: '+886',
    phoneNumber: '',
    phone: '',
    email: '',
    note: '',
    status: 2,
    paymentMethod: '',
    paymentStatus: 'UNPAID',
    basePrice: '',
    total: '',
    allowExpired: 0,
    coupon: undefined,
    couponCode: '',
    memberId: '',
    prepaidOrderUuid: '',
    byOrderExtrafields: {},
    customerInfos: [],
    productId: '',
    bankType: '',
    address: '',
    petId: '',
    city: '',
    district: '',
    type: 'deposit',
  }
}

export default {
  components: {
    BaseCollapse: () => lazyLoadComponent(import('@components/BaseCollapse')),
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    OrderChangeStatusDialog: () => lazyLoadComponent(import('@components/OrderChangeStatusDialog')),
    /* 重構元件 */
    MemberForm: () => lazyLoadComponent(import('./components/MemberForm')),
    MemberInfo: () => lazyLoadComponent(import('./components/MemberInfo')),
    PaymentEditForm: () => lazyLoadComponent(import('./components/PaymentEditForm')),
    TotalStatementDetail: () => lazyLoadComponent(import('./components/TotalStatementDetail')),
    OrderMemberInfo: () => lazyLoadComponent(import('./components/OrderMemberInfo')),
    DialogPaidConfirm: () => lazyLoadComponent(import('@components/Dialog/DialogPaidConfirm')),
    SignatureDialog: () => lazyLoadComponent(import('@components/SignatureDialog')),
    ProfitSharing: () => lazyLoadComponent(import('./components/ProfitSharing')),
  },
  filters: {
    orderPaymentMethodFilter,
    formatDate,
    paymentStatusMapFilter,
    genderFilter,
    orderStatusFilter,
    orderSourceFilter,
  },
  mixins: [depositOrderMixin],
  props: {
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
  },
  data() {
    return {
      orderHeaderId: `orderHeader__${Math.floor(Math.random() * 10000)}`,
      orderPaymentMethodMap,
      taxTypeMap,
      carrierTypeMap,
      headerHeight: 0,
      submitData: cloneDeep(this.defaultValue),
      currentOrder: cloneDeep(this.defaultValue),
      // 各種 show

      // 右邊的show，左邊有任何選擇，右邊的show要全部關掉
      memberInfoShow: false,
      editDetailEnabled: false,

      // 各種 loading
      tryingStore: false,
      tryingGetMember: false,

      paymentWay: 'offline',
      userSameAsMember: true,
      statusDialogVisible: false,

      orderHistoryShow: false,
      editPaymentMethodShow: false,
      tryingSendSMS: false,
      shareLink: '',
      shareDialogVisible: false,
      // 會員資訊
      memberInfo: {
        tags: [],
        phoneCode: '',
        phoneNumber: '',
        level: {}
      },
      memberInfoActiveTab: 'information',
      payMethods: {
        Cash: '到店付款(現金)',
        StoreCredit: '現場刷卡',
        Atm: '線下匯款',
      },
      tryingPayOrder: false,
      mapStatusName: {
        'PAID': '訂單資訊',
        'UNPAID': '付款',
      },
      // 付款確認Dialog
      isDialogPaidConfirmVisible: false,
      paidConfirmValue: {},
    }
  },
  computed: {
    currentHistory() {
      return this.currentOrder.history
    },
    depositReduce() {
      if (this.memberInfo.depositInfo === undefined) return 0

      const { bonus, point } = this.memberInfo.depositInfo.solution2.reduceDepositTotal
      return bonus + point
    },
    depositItem() {
      return this.defaultValue.params.find(({ type }) => type === 'deposit-plan') || {}
    },
    linkTitle() {
      const { childrenOrders } = this.defaultValue
      if (childrenOrders.length) {
        let hasUnpaid = false
        hasUnpaid = childrenOrders.some((order) => order.paymentStatus === 'UNPAID')
        return this.mapStatusName[hasUnpaid ? 'UNPAID' : 'PAID']
      } else return this.mapStatusName[this.defaultValue.paymentStatus]
    },
  },
  created() {
    this.fetchExtraInfo()
  },
  mounted() {
    const updateHeaderHeight = () => {
      this.$nextTick(() => {
        const interval = setInterval(() => {
          if (document.querySelector(`#${this.orderHeaderId}`) !== null) {
            clearInterval(interval)
            this.headerHeight = document.querySelector(`#${this.orderHeaderId}`).offsetHeight + 40
          }
        }, 500)
      })
    }
    console.log(this.defaultValue)
    updateHeaderHeight()
  },
  methods: {
    /**
     * @description emit上去關掉抽屜
     */
    closeEditDrawer() {
      this.statusDialogVisible = false
      this.$emit('closeEditDrawer')
    },
    fetchExtraInfo() {
      this.tryToFetchDetail(this.defaultValue.memberId)
    },
    closeAllInfo() {
      this.memberInfoShow = false
    },
    closeHistory() {
      this.orderHistoryShow = false
    },
    editOpenPaymentMethod(index) {
      this.currentOrder = cloneDeep(this.defaultValue)
      // 取得 bankType
      delete this.currentOrder.bankType
      if (this.currentOrder.Vacc) {
        this.currentOrder = {
          ...this.currentOrder,
          bankType: this.currentOrder.Vacc.BankType,
        }
      }
      this.editPaymentMethodShow = true
    },
    editOpenHistory(index) {
      this.currentOrder = cloneDeep(this.defaultValue)
      this.orderHistoryShow = true
    },
    tryToCancelOrder(index) {
      this.currentOrder = cloneDeep(this.defaultValue)
      this.statusDialogVisible = true
    },
    /**
     * @description 顯示選擇發送方式Dialog
     */
    showShareDialog() {
      this.shareDialogVisible = true
    },
    async tryToGetShareLink() {
      this.shareLink = await this.$store.dispatch('order/getLink', this.defaultValue.id)
    },
    handleShareLink(platform) {
      const platformLinkMap = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${this.shareLink}`,
        line: `https://social-plugins.line.me/lineit/share?url=${this.shareLink}`,
      }
      window.open(platformLinkMap[platform], '_blank')
    },
    async tryToSendSMS() {
      this.tryingSendSMS = true
      try {
        await this.$store.dispatch('order/sendLink', {
          orderId: this.defaultValue.id,
          router: 'sms',
        })
        this.$alert(`已發送${this.linkTitle}連結簡訊至使用人電話`, '簡訊發送成功！', {
          confirmButtonText: '確認',
          center: true,
        })
      } finally {
        this.tryingSendSMS = false
      }
    },
    async copyShareLink() {
      const ghostInput = document.createElement('INPUT')
      document.body.appendChild(ghostInput)
      ghostInput.setAttribute('value', this.shareLink)
      ghostInput.select()
      document.execCommand('copy')
      document.body.removeChild(ghostInput)

      if (process.env.VUE_APP_BUILD_MODE === 'admin-app-build') {
        await Clipboard.write({
          string: this.shareLink,
        })
      }

      this.$message('連結複製成功')
    },
    /***** 付款確認  Start *****/
    async paidConfirm() {
      const paymentMethod = this.paidConfirmValue.paymentMethod
      this.tryToPayOrder(paymentMethod, this.paidConfirmValue)
    },
    openPaidDialog() {
      this.isDialogPaidConfirmVisible = true
      this.paidConfirmValue = this.submitData
    },
    /***** 付款確認  End *****/
    async tryToPayOrder(paymentMethod, data) {
      try {
        const { params, ...other } = data
        let storeData = {
          ...other,
          paymentMethod,
          paymentStatus: 'PAID',
          uuid: data.orderContainerUuid,
          total: data.unpaidTotal,
        }
        await this.setInvoiceInfo(storeData, 'deposit-detail')
        storeData = Object.assign({}, storeData, this.invoiceStoreData)
        this.tryingPayOrder = true

        await this.$store.dispatch('order/storeContainerId', storeData)
        this.$message({
          type: 'success',
          message: '編輯成功！',
        })
        this.updateOrder()
        this.paidDialogVisible = false
        this.tryToFetchDetail(this.memberInfo.id)
      } finally {
        this.tryingPayOrder = false
      }
    },
    async tryToSaveOrder() {
      const { params, ...other } = this.currentOrder
      let storeData = {
        ...other,
        merchantNote: '',
      }

      this.tryingStore = true
      try {
        await this.$store.dispatch('order/store', storeData)
        this.handleSaveSuccess()
        await this.updateOrder()
        this.editPaymentMethodShow = false
      } catch (error) {
        this.$message({
          type: 'error',
          message: `Server Error`,
        })
      } finally {
        this.tryingStore = false
      }
    },
    handleSaveSuccess() {
      this.$message({
        message: '編輯成功！',
        type: 'success',
      })
    },
    /**
     * @description 付款之後，更新submitData資料
     */
    async updateOrder() {
      const updatedValue = await this.$store.dispatch('deposit/fetchSingleOrder', this.defaultValue.id)
      this.$emit('update:defaultValue', updatedValue)
      this.$emit('updateDrawerData', updatedValue.id, () => {
        this.submitData = cloneDeep(this.defaultValue)
        this.currentOrder = cloneDeep(this.defaultValue)
      })
      this.$emit('update')
    },
    /************ 編輯客戶資訊相關 start ************/
    closeEditMemberForm() {
      this.editDetailEnabled = false
    },
    async tryToFetchDetail(memberId) {
      this.tryingGetMember = true
      this.memberInfo = await this.$store.dispatch('member/fetchSingle', { memberId })
      this.closeEditMemberForm()
      this.tryingGetMember = false
    },
    /************ 編輯客戶資訊相關 end ************/

    /************ 客戶資訊相關 start ************/
    closeMemberInfo() {
      this.memberInfoShow = false
    },
    /************ 客戶資訊相關 end ************/
    /****** 客戶資訊 ******/
    goToMemberInfoDetail(val) {
      this.closeAllInfo()
      this.closeHistory()
      this.editPaymentMethodShow = false
      this.memberInfoShow = true
      this.memberInfoActiveTab = val
    },
    /****** 客戶資訊 end ******/
    /************ 變更付款方式相關 start ************/
    onUpdatePayment(data) {
      const { allowExpired, paymentMethod, Card4No, PayerAccount5Code, bankType } = data
      this.currentOrder = {
        ...this.currentOrder,
        allowExpired,
        paymentMethod,
        Card4No,
        PayerAccount5Code,
        bankType,
      }
      this.tryToSaveOrderForContainer(this.currentOrder)
    },
    /**
     * @description 改成containerStore
     */
    async tryToSaveOrderForContainer(data) {
      const { params, paymentMethod, paymentStatus, ...other } = data
      let storeData = {
        ...other,
        paymentMethod,
        paymentStatus,
        uuid: data.orderContainerUuid,
        total: data.unpaidTotal,
      }
      this.tryingPayOrder = true
      await this.$store.dispatch('order/storeContainerId', storeData)
      this.$message({
        type: 'success',
        message: '編輯成功！',
      })
      this.updateOrder()
      this.tryToFetchDetail(this.memberInfo.id)
      this.tryingPayOrder = false
      this.editPaymentMethodShow = false
    },
    closeEditPaymentMethod() {
      this.editPaymentMethodShow = false
    },
    /************ 變更付款方式相關 end ************/
  },
}
</script>
<template>
  <div v-loading="tryingGetMember" :class="$style.orderformSection">
    <div class="orderformSection__all">
      <div class="orderformSection__left">
        <div :id="orderHeaderId" :class="$style.header">
          <h5 class="Jost" :class="$style.title">{{ defaultValue.orderContainerDisplayId }}</h5>
          <div class="inline-between" style="padding-right: 20px">
            <span>{{ defaultValue.created }} 成立訂單</span>
            <span>訂單來源：{{ defaultValue.source | orderSourceFilter }}</span>
          </div>
        </div>
        <div ref="leftCont" class="orderformSection__left__content" :style="`height:calc(100vh - ${headerHeight}px)`">
          <div style="min-height: 300px; padding-top: 20px" class="info-section">
            <!-- 客戶資訊 -->
            <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
              <template v-slot:title>
                <span>
                  <BaseIcon icon-style="fal" name="address-card"
                    :class="[$style['header-icon-left'], 'fs-2xl', 'mr-3', 'align-text-bottom']" />
                  客戶資訊
                </span>
              </template>
              <OrderMemberInfo :member-info="memberInfo" @toDetail="goToMemberInfoDetail" />

            </BaseCollapse>
            <!-- 儲值方案 -->
            <BaseCollapse expanded is-order :order-theme="true">
              <template v-slot:title>
                <span>
                  <BaseIcon icon-style="fal" name="usd-circle" :class="[$style['header-icon-left'], 'fs-lg', 'mr-3']" />
                  選擇儲值方案
                </span>
              </template>
              <div class="px-md-3 p-0">
                <span class="fs-medium text-secondary">儲值方案</span>
                <div class="mt-3">{{ depositItem.title }}</div>
              </div>
            </BaseCollapse>
            <template>
              <ProfitSharing order-type="deposit" :order-info="defaultValue" @updateOrder="updateOrder" />
            </template>
          </div>
        </div>
      </div>
      <div class="orderformSection__right">
        <template>
          <!-- 客戶編輯 -->
          <template v-if="editDetailEnabled">
            <MemberForm :default-value="memberInfo" @update="tryToFetchDetail" @close="closeEditMemberForm" />
          </template>
          <!-- 客戶資訊 -->
          <template v-if="memberInfoShow && !editDetailEnabled">
            <MemberInfo :member-info="memberInfo" :member-info-active-tab="memberInfoActiveTab" @update="tryToFetchDetail"
              @close="closeMemberInfo" />
          </template>
          <!-- 查看歷史紀錄 -->
          <template v-if="orderHistoryShow">
            <div class="orderformSection__right__header">
              <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="closeHistory"><i
                  class="el-dialog__close el-icon el-icon-close"></i></button>
              <h4 class="orderformSection__right__title">訂單變更記錄</h4>
            </div>
            <div class="orderformSection__right__content">
              <el-timeline>
                <el-timeline-item v-for="log in currentHistory" :key="log.id"
                  :timestamp="log.created | formatDate('dateTime')" type="primary" placement="top">
                  {{ log.description }}
                  <span style="font-size: 13px">
                    <span v-if="log.creator">- {{ log.creator }}</span>
                  </span>
                  <div v-if="log.note">{{ log.note }}</div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </template>
          <!-- 編輯付款方式 -->
          <template v-if="editPaymentMethodShow">
            <PaymentEditForm :current-order="currentOrder" :loading="tryingStore" @update="onUpdatePayment"
              @close="closeEditPaymentMethod" />
          </template>
        </template>
        <!-- 變價 -->
        <div :class="$style.total">
          <div class="total__cont">
            <TotalStatementDetail order-type="deposit" :default-value="submitData"
              @editOpenPaymentMethod="editOpenPaymentMethod" @editOpenHistory="editOpenHistory"
              @tryToCancelOrder="tryToCancelOrder">
            </TotalStatementDetail>
          </div>
        </div>
      </div>

      <!-- 底部按鈕 -->
      <div class="orderformSection__bottom">
        <div style="display: flex; align-items: center">
          <BaseStateLabel v-if="defaultValue.status === 0" :state="defaultValue.status | orderStatusFilter('color')"
            class="is-border">
            {{ defaultValue.status | orderStatusFilter('text') }}
          </BaseStateLabel>
          <BaseStateLabel v-else :state="defaultValue.paymentStatus | paymentStatusMapFilter('color')" class="is-border">
            {{ defaultValue.paymentStatus | paymentStatusMapFilter('text') }}
          </BaseStateLabel>
          <div style="padding-left: 1.25rem" class="text-secondary fw-medium Jost">
            <span>應付 NT${{ defaultValue.allActualPayTotal }}</span>
            <br />
            <BaseStateLabel class="text-muted-0" style="padding-top: 5px" state="info" text>{{ defaultValue.paymentMethod
              | orderPaymentMethodFilter }}</BaseStateLabel>
          </div>
        </div>

        <div style="flex-shrink:0;padding:0 10px; margin-left: auto;">
          <el-button v-if="defaultValue.status !== 0" style="font-size: 20px"
            class="no-color-text-btn is-circle is-border" @click="showShareDialog">
            <BaseIcon name="paper-plane" :icon-style="'fal'">
            </BaseIcon>
          </el-button>
          <!-- 分享連結 -->
          <el-dialog title="選擇發送方式" :visible.sync="shareDialogVisible" top="0" width="680px" append-to-body lock-scroll
            @open="tryToGetShareLink">
            <ul class="p-3 mb-3" style="border-radius: 8px; background: $color-line">
              <li class="text-primary mb-3">{{ `#${defaultValue.orderContainerDisplayId}` }}</li>
              <li class="mb-3">使用人：{{ defaultValue.fullName }} {{ defaultValue.gender | genderFilter }}</li>
              <li>訂購內容：{{ defaultValue.productName }} {{ defaultValue.date | formatDate }} {{ defaultValue.time }}</li>
            </ul>
            <div :class="$style['share__buttons']">
              <div :class="$style['share__button']">
                <el-button type="text" class="isPrimary" :class="$style['share__button']"
                  @click="handleShareLink('facebook')">
                  <i class="fab fa-facebook-square" :class="$style['share__icon']"></i>
                </el-button>
                <div :class="$style['share__label']">Facebook</div>
              </div>
              <div :class="$style['share__button']">
                <el-button type="text" class="isPrimary" :class="$style['share__button']"
                  @click="handleShareLink('line')">
                  <BaseIcon :class="$style['share__icon']" name="line" icon-style="fab" />
                </el-button>
                <div :class="$style['share__label']">Line</div>
              </div>
              <div :class="$style['share__button']" :loading="tryingSendSMS">
                <el-button type="text" class="isPrimary" :class="$style['share__button']" @click="tryToSendSMS">
                  <i class="fas fa-sms" :class="$style['share__icon']"></i>
                </el-button>
                <div :class="$style['share__label']">簡訊</div>
              </div>
              <div :class="$style['share__button']">
                <el-button type="text" class="isPrimary" :class="$style['share__button']" @click="copyShareLink">
                  <i class="fas fa-copy" :class="$style['share__icon']"></i>
                </el-button>
                <div :class="$style['share__label']">複製連結</div>
              </div>
            </div>
          </el-dialog>
        </div>

        <div style="flex-shrink:0">
          <el-button
            v-if="defaultValue.status !== 0 && defaultValue.paymentStatus === 'UNPAID' && defaultValue.paymentMethod !== 'Credit' && defaultValue.paymentMethod !== 'Vacc'"
            class="is-round orderformSection__bottom__btn-item" type="success" :loading="tryingPayOrder"
            @click="openPaidDialog">付款</el-button>
        </div>
      </div>
    </div>

    <OrderChangeStatusDialog :visible.sync="statusDialogVisible" :order="{ ...currentOrder, status: 0 }"
      @cancelled="updateOrder" @emitStore="closeEditDrawer" />
    <!-- 付款確認 -->
    <DialogPaidConfirm v-model="paidConfirmValue" :visible.sync="isDialogPaidConfirmVisible" @submit="paidConfirm" />
    <!-- 簽名請款 -->
    <SignatureDialog :one-step="true" :start-tab="1" :member-info="memberInfo" :props-store-invoice-setting="1"
      :visible.sync="signDialogVisible" :order="{ ...submitData }" @closeSignature="closeSignature"
      @closeSignaturDialog="closeSignaturDialog" />
  </div>
</template>
<style lang="scss" module>
@import '@design';

.orderformSection {

  // display: flex;
  // flex-wrap: wrap;
  // height: 100%;
  :global {
    .form-block-title {
      font-size: 16px;
      padding-bottom: 0;
      margin-top: 0;
    }

    .el-form-item {
      // margin-bottom: 10px;
    }

    .el-tabs__active-bar {
      background-color: $color-primary !important;
    }

    .info-section {
      padding: 30px 40px;

      @include max-lg {
        padding: 15px 20px;
      }
    }

    .orderformSection {
      &__all {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        // display: none;
      }

      &__left {
        width: 57%;
        border-right: $color-border-base 1px solid;
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        background: $color-line;

        &__content {
          height: 100vh;
          overflow: auto;

          padding-bottom: 90px;
        }
      }

      &__right {
        position: relative;
        width: 43%;
        background: $color-line;

        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }

        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;

          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }

          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__header {
            margin-bottom: 0;
          }

          .el-tabs--top {
            margin-left: 60px;

            @include max-lg {
              margin-left: 30px;
            }
          }
        }

        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;

          @include max-lg {
            padding: 20px;
          }
        }
      }

      &__bottom {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 30px;
        background: #fff;
        box-shadow: 0 -5px 5px rgba(#eee, 0.3);
        z-index: 999;

        @include touch {
          position: static;
          // position: fixed;
        }

        &__btn {
          width: 40%;
        }

        &__btn-item {
          // min-width: 132px;
          width: 360px;
          max-width: 100%;

          @include max-lg {
            width: 100%;
          }
        }
      }
    }
  }
}

.header {
  margin-top: 5px;
  // margin-bottom: 30px;
  padding-right: 40px;
  padding-left: 60px;
  padding-bottom: 10px;
  border-bottom: $color-border-base 1px solid;

  @include max-lg {
    padding-right: 20px;
  }

  :global {
    h5 {
      font-size: 18px;
    }
  }
}

.title:not(:first-child) {
  margin-top: 30px;
}

.infoList {
  // margin-bottom: 30px;
  padding-top: 5px;

  // border-bottom: 1px solid $color-border-base;
  // font-size: 16px;
  :global {
    .muted {
      color: $color-text-secondary;
    }

    .el-tag+.el-tag {
      margin-left: 10px;
    }

    .infoList {
      &__title {
        font-weight: 500;
        margin-bottom: 20px;
      }

      &__item {
        margin-bottom: 15px;
      }

      &__row {
        margin-bottom: 20px;
      }
    }
  }
}

.total {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 100%;
  z-index: 1;

  @include touch {
    position: static;
  }

  :global {
    .total {
      &__cont {
        // padding: 30px 30px;
        height: calc(100% - 80px);

        @include touch {
          height: auto;
        }
      }

      &__bottom {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 30px;
        background: #fff;
        box-shadow: 0 -5px 5px rgba(#eee, 0.3);
        z-index: 999;

        @include touch {
          // position: static;
          position: sticky;
          flex-wrap: wrap;
          padding: 15px;
          justify-content: flex-start;
        }

        &__left {
          @include touch {
            width: 100%;
          }
        }

        &__btn {
          width: 40%;
        }

        &__btn-item {
          // min-width: 132px;
          width: 360px;
          max-width: 100%;

          @include max-lg {
            width: 100%;
          }
        }

        &__right {
          display: flex;
          align-items: center;
          margin-left: 1rem;

          &__alert {
            display: inline-block;
            width: auto;
            margin-left: 20px;
            flex-shrink: 0;

            @include touch {
              width: 100%;
              margin-left: 0;
              margin-top: 1rem;
            }
          }

          @include touch {
            display: block;
            width: 100%;
            margin-left: 0;
            order: -1;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

.bottom {
  /* position: absolute;
  bottom: 0; */
  width: 100%;
  padding: 0 30px 0;

  @include touch {
    position: static;
  }
}

.invoice {
  :global {
    .order-id {
      font-size: 16px;
      letter-spacing: 1.6px;
      line-height: 18px;
      margin-bottom: 20px;
      font-weight: 500;
    }

    .info {
      padding: 22.5px 20px;
      background: white;

      @include touch {
        border: 1px solid #c6c6ba;
      }

      .el-col {
        padding-top: 7.5px;
        padding-bottom: 7.5px;
      }

      .info-item {
        .title {
          width: 60px;
          display: inline-block;
          color: #919191;
          margin-right: 20px;
        }

        &+.info-item {
          margin-top: 15px;
        }
      }
    }
  }

  &+.invoice {
    margin-top: 40px;
  }
}

.titleBox {
  padding: 20px;
  background: #fff;
}

.share {
  &__buttons {
    display: flex;
    align-items: center;
    text-align: center;
  }

  &__button {
    flex: 1;
  }

  &__icon {
    font-size: 3rem;
  }

  &__label {
    margin-top: 10px;
  }
}
</style>
